/**
 * Apcam.Api.Web
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const ExportEntityType = {
    ClientProfile: 1
} as const;
export type ExportEntityType = typeof ExportEntityType[keyof typeof ExportEntityType];

